var map = {
	"./_base-bg-component.vue": "4265",
	"./_base-button-angle.vue": "19d7",
	"./_base-button.vue": "8339",
	"./_base-conections.vue": "4c33",
	"./_base-hotspot.vue": "8637",
	"./_base-icon.vue": "670f",
	"./_base-indicator.vue": "4654",
	"./_base-input-text.vue": "9c57",
	"./_base-link.vue": "cbd4",
	"./_base-menu-button.vue": "7161",
	"./_base-popover.vue": "5ef0",
	"./_base-side-drawer.vue": "cf54",
	"./_base-vidplayer.vue": "dfa3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b526";